import React from 'react';
import Swiper from 'react-id-swiper';
import styled from 'styled-components';
import 'swiper/css/swiper.css';

const DefaultSwiper = ({ children }) => {
  const params = {
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  };
  return <Swiper {...params}>{children}</Swiper>;
};

export default DefaultSwiper;

export const FractionSwiper = ({
  children,
  params = FRACTION_PARAMS,
  ...props
}) => {
  return (
    <FractionSwiperContainer {...props}>
      <Swiper {...params}>{children}</Swiper>
    </FractionSwiperContainer>
  );
};

const FRACTION_PARAMS = {
  pagination: {
    el: '.swiper-pagination',
    type: 'fraction',
    spaceBetween: 0,
    slidesPerView: 'auto',
  },
};

export const FractionSwiperContainer = styled.div`
  width: 100%;

  .swiper-pagination {
    display: ${({ videoIndices = [], currentIndex = 0 }) =>
      videoIndices.includes(currentIndex) ? 'none' : 'block'};
    color: white;
    border-radius: 20px;
    background-color: #161616;
    font-size: 0.75rem;
    padding: 0.25rem;
    opacity: 0.3;
  }

  .swiper-pagination-fraction {
    width: 3.5rem;
    left: 80%;
  }
`;
